import DropBoxDataStore from '../datastores/DropBoxDataStore';
import DropBoxDataStoreFactory from '../factories/DropBoxDataStoreFactory';
import DropBoxRepository from '../../domain/repositories/DropBoxRepository';

export default class DropBoxDataRepostory implements DropBoxRepository {
  generateUrlDocument(path: string, token: string) {
    const ResponseDropBoxDataStore: DropBoxDataStore =
      DropBoxDataStoreFactory.create();
    return ResponseDropBoxDataStore.generateUrlDocument(path, token);
  }
}
